export const AppUserSetting={
    signature:null,
    need_notification:false,
    need_tfa:false,
    mark_alert:false,
    useful_alert:false,
    agenda_alert:false,
    reminder_alert:false,
    timetable_alert:false

}